import { trans as _trans } from './translator.js';

export const trans = (id, parameters) => {
    // get local from html lang attribute, default to 'fr-FR' if not found
    const locale = document.documentElement.lang || 'fr-FR';
    return _trans(id, parameters, 'display_shop', locale);
};
